<template>
  <div class="stationeryRecord-content-item" v-show="isCurrentContentItem">
    <!-- v-bitmap="getListResult" -->
    <stationeryRecordList :stationeryRecordList="stationeryRecordData" class="stationeryRecord-list-content-main"
      :stationeryList="stationeryList" :stationeryDetailsList="stationeryDetailsList"
      @revocation="getStationeryRecordList" :currentLabel="currentLabel" @edit="selectStationeryRecordByMySelf"
      @revocationRefresh="selectStationeryRecordByMySelf" @updateStatus="updateStatus" />
    <pagination :pageSize="pageSize" :total="total" @currentPageNumChange="currentPageNumChange"
      @handleSizeChange="handleSizeChange"></pagination>
  </div>
</template>

<script>
import stationeryRecordList from "../stationeryRecord-list/stationeryRecord-list.vue";

export default {
  data() {
    return {
      total: 0,
      pageSize: 10,
      pageNum: 1,
      stationeryRecordData: [], // 申请记录
      stationeryDetailsList: [], // 申请统计
      getListResult: "nullData",
      testTotal: 1,
    };
  },
  components: {
    stationeryRecordList,
  },
  props: {
    isCurrentContentItem: {
      type: Boolean,
    },
    currentStatus: {
      type: Number,
      require: true,
    },
    changeStatus: {
      type: Number,
    },
    searchStationeryName: {
      type: String,
    },
    searchTeacherName: {
      type: String,
    },
    stationeryList: {
      type: Array,
    },
    date: {
      type: [Array, String],
    },
    currentLabel: {
      type: String
    }
  },
  watch: {
    // 切换列表显示
    isCurrentContentItem: {
      handler(val) {
        if (val && this.currentLabel == '我的申请')
          return this.selectStationeryRecordByMySelf();
        if (val && this.currentLabel == '申请统计')
          return this.selectStationeryDetailsList();
        if (val) {
          this.getStationeryRecordList();
          // console.log('切换1');
        }
      },
      immediate: true,
    },
    // 状态切换
    changeStatus: {
      handler(val) {
        if (val) {
          this.stationeryRecordData = null;
          if (this.isCurrentContentItem) {
            if (this.currentLabel == '我的申请') return this.selectStationeryRecordByMySelf();
            this.getStationeryRecordList();
          }
        }
      },
      immediate: true,
    },
    searchTeacherName() {
      // console.log("item==>", this.searchContent);
      this.stationeryRecordData = null;
      if (this.isCurrentContentItem) {
        if (this.currentLabel == '申请统计') return this.selectStationeryDetailsList();
        if (this.currentLabel == '我的申请') return this.selectStationeryRecordByMySelf();
        this.getStationeryRecordList();
      }
    },
    searchStationeryName() {
      // console.log("item==>", this.searchContent);
      this.stationeryRecordData = null;
      if (this.isCurrentContentItem) {
        if (this.currentLabel == '申请统计') return this.selectStationeryDetailsList();
        if (this.currentLabel == '我的申请') return this.selectStationeryRecordByMySelf();
        this.getStationeryRecordList();
      }
    },
    date() {
      // console.log("item==>", this.searchContent);
      this.stationeryRecordData = null;
      if (this.isCurrentContentItem) {
        if (this.currentLabel == '申请统计') return this.selectStationeryDetailsList();
        if (this.currentLabel == '我的申请') return this.selectStationeryRecordByMySelf();
        this.getStationeryRecordList();
      }
    }
  },
  created() {
  },
  mounted() { },
  methods: {
    updateStatus(e) {
      if (this.currentLabel == '申请统计') return this.selectStationeryDetailsList();
      if (this.currentLabel == '我的申请') return this.selectStationeryRecordByMySelf();
      this.getStationeryRecordList();
    },
    // 查询我的申请记录
    selectStationeryRecordByMySelf() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        startTime: this.date ? this.date[0] : '',
        endTime: this.date ? this.date[1] : '',
      };
      this.get(this.$url.selectStationeryRecordByMySelf, data)
        .then((res) => {
          // console.log("查询我的申请记录==>", res);
          // this.stationeryRecordList = res.rows;
          if (res.code != 200) {
            this.getListResult = "error";
            this.$message.error(res.msg);
            return;
          }
          let data = res;
          this.total = data.total;
          this.stationeryRecordData = data.rows;
          this.total > 0
            ? (this.getListResult = "success")
            : (this.getListResult = "nullData");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取申请统计
    selectStationeryDetailsList() {
      let data = {
        teacherName: this.searchTeacherName,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        itemName: this.searchStationeryName,
        startTime: this.date ? this.date[0] : '',
        endTime: this.date ? this.date[1] : '',
      };
      this.get(this.$url.selectStationeryDetailsList, data)
        .then((res) => {
          // console.log("查询申请统计列表==>", res);
          this.stationeryDetailsList = res.rows.map((item) => {
            return (item.statusText =
              item.status == "0"
                ? "待审批"
                : item.status == "1"
                  ? "通过"
                  : "驳回");
          });
          if (res.code != 200) {
            this.getListResult = "error";
            this.$message.error(res.msg);
            return;
          }
          let data = res;
          this.total = data.total;
          this.stationeryDetailsList = data.rows;
          this.total > 0
            ? (this.getListResult = "success")
            : (this.getListResult = "nullData");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取审批列表
    getStationeryRecordList() {
      // console.log(this.searchContent);
      let status = this.currentLabel == '待审批' ? '0' : this.currentLabel == '审批通过' ? '1' : this.currentLabel == '审批拒绝' ? '2' : '3';
      let data = {
        teacherName: this.searchTeacherName,
        status, // （0：待审批 1：通过 2：驳回 3：申请统计,
        startTime: this.date ? this.date[0] : '',
        endTime: this.date ? this.date[1] : '',
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.get(this.$url.selectStationeryRecordList, data)
        .then((res) => {
          // console.log("查询申请记录列表==>", res);
          // this.stationeryRecordList = res.rows;
          if (res.code != 200) {
            this.getListResult = "error";
            this.$message.error(res.msg);
            return;
          }
          let data = res;
          this.total = data.total;
          this.stationeryRecordData = data.rows;
          this.total > 0
            ? (this.getListResult = "success")
            : (this.getListResult = "nullData");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 分页
    currentPageNumChange(e) {
      this.pageNum = e;
      if (this.currentLabel == '申请统计') return this.selectStationeryDetailsList();
      if (this.currentLabel == '我的申请') return this.selectStationeryRecordByMySelf();
      this.getStationeryRecordList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      if (this.currentLabel == '申请统计') return this.selectStationeryDetailsList();
      if (this.currentLabel == '我的申请') return this.selectStationeryRecordByMySelf();
      this.getStationeryRecordList();
    },
    revocation(e) {
      this.$emit("revocation", e);
    },
    // 搜索
    // search(e) {
    //   // console.log(e);
    //   this.stationeryRecordList = null;
    //   if (e == "") {
    //     this.searchContent = "";
    //     this.getStationeryRecordList();
    //   } else {
    //     this.searchContent = e;
    //     this.getStationeryRecordList();
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
@import "./stationeryRecord-content-item.scss";
</style>